import { insertPlantMutation, updatePlantOrderMutation } from '@/lib/apollo/mutations';
import { usePlants } from '@/lib/store';
import { useMutation } from '@apollo/client';
import { isNotEmpty, useForm } from '@mantine/form';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import _ from 'lodash';
import { useSession } from 'next-auth/react';
import { useState } from 'react';

import { PlantDetailsForm } from '../forms';

const PlantDetailsStep = ({ formData, toggleOverlay }) => {
    const [activeChecked, setActiveChecked] = useState(true);
    const [maintenanceChecked, setMaintenanceChecked] = useState(false);
    const [repairingChecked, setRepairingChecked] = useState(false);
    const [sendAlertNotificationChecked, setSendAlertNotificationChecked] = useState(true);

    const { data: session } = useSession();

    const form = useForm({
        initialValues: {
            name: formData.selectedPlant?.name || '',
            url: formData.url || '',
            apiType: formData.apiType || '1',
            targetPerformanceRatio: formData.targetPerformanceRatio || '70',
            temperatureCoefficient: formData.temperatureCoefficient || '0',
            minimumTriggerThreshold: formData.minimumTriggerThreshold || '0',
            tare: formData.tare || '0',
            solarimeter: formData.solarimeter?.toString() || '1',
            refreshInterval: formData.refreshInterval || '5',
            details: formData.details || '',
            plantPower: formData.selectedPlant?.plantPower || '0.01',
        },
        validate: {
            name: isNotEmpty('Il nome impianto non può essere vuoto.'),
            url: (value, values) =>
                isNotEmpty("L'URL impianto non può essere vuoto.")(value) ||
                (values.apiType === '6' && !/^\S+\|\S+(\|\S+)?$/.test(value) ? 'Formato richiesto: URL|token oppure URL|token|URL apertura' : null),
            plantPower: isNotEmpty("La potenza dell'impianto non può essere vuota."),
        },
    });

    const { plantOrder } = usePlants();

    const [updatePlantOrder] = useMutation(updatePlantOrderMutation, {
        refetchQueries: ['getPlants', 'getPlantOrder'],
        onCompleted: () => {
            notifications.show({
                title: 'Operazione completata',
                message: 'Impianto aggiunto correttamente',
                color: 'teal',
            });
            toggleOverlay();
            modals.closeAll();
        },
    });

    const [insertPlant] = useMutation(insertPlantMutation, {
        onCompleted: (data) => {
            let order = _.cloneDeep(plantOrder);
            order.push(data.insertPlant.id);
            updatePlantOrder({ variables: { email: session.data.email, order } });
        },
    });

    return (
        <PlantDetailsForm
            form={form}
            onSubmit={form.onSubmit((values) => {
                toggleOverlay();
                insertPlant({
                    variables: {
                        extId: parseInt(formData.selectedPlant?.id),
                        name: values.name,
                        url: values.url,
                        apiTypeId: parseInt(values.apiType),
                        targetPerformanceRatio: values.targetPerformanceRatio || 0,
                        temperatureCoefficient: values.temperatureCoefficient || 0,
                        minimumTriggerThreshold: values.minimumTriggerThreshold || 0,
                        tare: values.tare || 0,
                        solarimeter: Boolean(parseInt(values.solarimeter)),
                        refreshInterval: values.refreshInterval || 5,
                        details: values.details,
                        active: activeChecked,
                        maintenance: maintenanceChecked,
                        repairing: repairingChecked,
                        sendAlertNotification: sendAlertNotificationChecked,
                        plantPower: values.plantPower,
                    },
                });
            })}
            activeChecked={activeChecked}
            maintenanceChecked={maintenanceChecked}
            repairingChecked={repairingChecked}
            sendAlertNotificationChecked={sendAlertNotificationChecked}
            setActiveChecked={setActiveChecked}
            setMaintenanceChecked={setMaintenanceChecked}
            setRepairingChecked={setRepairingChecked}
            setSendAlertNotificationChecked={setSendAlertNotificationChecked}
        />
    );
};

export default PlantDetailsStep;
